import { Controller } from "@hotwired/stimulus"

// Przelaczanie tabow Dashboard / Moduly na stronie glownej.
// Zakladka Dashboard ma ciezka zawartosc (KPI + widgety), wiec nie ladujemy jej przy wejsciu
// na "/". Przy PIERWSZYM przelaczeniu pobieramy ja w tle (panel zostaje ukryty, wiec user nie
// widzi stanu ladowania) i odslaniamy karte dopiero gdy tresc dojdzie - zakladka sprawia wrazenie
// od razu gotowej. Kolejne przelaczenia sa natychmiastowe (ramka jest juz zaladowana).
// Wybor zakladki nie jest zapamietywany - wejscie na "/" zawsze startuje na "Moduly".
export default class extends Controller {
  static targets = ["tab", "btn", "frame"]
  static values = {
    url: String,
    active: { type: String, default: "text-xs text-blue-600 font-medium border-b border-blue-500 pb-1" },
    inactive: { type: String, default: "text-xs text-gray-400 hover:text-gray-600 pb-1" },
    // Max czas oczekiwania na zawartosc zanim przelaczymy mimo wszystko (fallback dla wolnej sieci)
    timeout: { type: Number, default: 1500 }
  }

  switch(event) {
    const selected = event.currentTarget.dataset.tab
    this.pendingTab = selected

    // Pierwsze wejscie w zakladke z leniwa ramka - pobierz w tle, odslon dopiero po zaladowaniu
    const tab = this.tabTargets.find(t => t.id === selected)
    if (this.hasFrameTarget && !this.frameLoaded && tab && tab.contains(this.frameTarget)) {
      this.loadThenSwitch(selected)
      return
    }

    this.activate(selected)
  }

  // Ustawia src ramki (start pobierania) i czeka na turbo:frame-load. Podswietlenie zakladki
  // przeskakuje od razu (klik widocznie reaguje), ale panel pozostaje ukryty az tresc dojdzie.
  loadThenSwitch(selected) {
    this.setButtons(selected)
    if (this.loading) return
    this.loading = true

    const reveal = () => {
      if (!this.loading) return
      this.loading = false
      this.frameLoaded = true
      clearTimeout(this.timer)
      // Jesli user w miedzyczasie wrocil na inna zakladke, nie wymuszaj przeskoku
      if (this.pendingTab === selected) this.activate(selected)
    }

    this.frameTarget.addEventListener("turbo:frame-load", reveal, { once: true })
    // Fallback: wolna siec — przelacz po timeoutcie, tresc wskoczy gdy dojdzie
    this.timer = setTimeout(reveal, this.timeoutValue)

    this.frameTarget.src = this.urlValue
  }

  // Pelne przelaczenie: widocznosc paneli + styl przyciskow
  activate(selected) {
    this.tabTargets.forEach(tab => {
      tab.classList.toggle("hidden", tab.id !== selected)
    })
    this.setButtons(selected)
  }

  // Tylko styl przyciskow (wskaznik aktywnej zakladki)
  setButtons(selected) {
    this.btnTargets.forEach(btn => {
      btn.className = btn.dataset.tab === selected ? this.activeValue : this.inactiveValue
    })
  }
}
